// File: /js/pages/menu.js
//
// Mobile slide-in menu toggle. The hamburger
// (#menu-toggle[data-ui="menu-toggle"]) rides the shared data-ui click
// registry (no new document listener); the backdrop and menu links close it.
// The `.open` state on the toggle, the panel (#mobile-menu-wrapper) and the
// backdrop (#menu-overlay-backdrop) is what layout/menu.css + header.css
// animate. Inert on desktop, where the nav renders inline.

import { registerUiHandler } from '/js/shared/extensions/domExtensions.js';

function parts() {
  return {
    toggle:   document.getElementById('menu-toggle'),
    wrapper:  document.getElementById('mobile-menu-wrapper'),
    backdrop: document.getElementById('menu-overlay-backdrop'),
  };
}

function setOpen(open) {
  const { toggle, wrapper, backdrop } = parts();
  [toggle, wrapper, backdrop].forEach((el) => el && el.classList.toggle('open', open));
}

registerUiHandler('click', 'menu-toggle', () => {
  const { wrapper } = parts();
  const isOpen = wrapper ? wrapper.classList.contains('open') : false;
  setOpen(!isOpen);
});

document.addEventListener('DOMContentLoaded', () => {
  const { backdrop, wrapper } = parts();
  if (backdrop) backdrop.addEventListener('click', () => setOpen(false));
  if (wrapper) {
    wrapper.querySelectorAll('a.headlink').forEach((a) => {
      a.addEventListener('click', () => setOpen(false));
    });
  }
});
